<template>
  <div class="drawer">
    <v-navigation-drawer v-model="mini" app permanent :class="{collapseMenu: !mini}"><!--v-bind="$props" :class="{collapseMenu: !mini}" :mini-variant.sync="mini" expand-on-hover-->

      <v-list-item link>
        <v-list-item-title class="drawer__logo d-flex justify-center">
          <Img v-if="!mini" :src="getImgWithExt(['images', 'logo_drawer_short', 'svg'])" width="40" height="40" />
          <Img v-else :src="getImgWithExt(['images', 'logo_drawer', 'svg'])" width="170" />
        </v-list-item-title>
      </v-list-item>

      <v-list nav dense>
        <template v-for="(item, i) in filteredItemsOnlyAuth"><!--items-->
          <v-list-item  :key="i" @click="goToByLink(item)" :class="{'active-tab': item.name.toLowerCase() === $route.name.toLowerCase()}"><!-- v-if="isVisible(item)"-->
            <v-list-item-icon class="align-self-center">
              <template v-if="item.name === 'Patients' && !mini">
                <v-badge
                  style="display: flex"
                  color="#7cdbc1"
                  v-if="totalCountPatients && totalCountPatients.pagination"
                  :value="totalCountPatients.pagination.total"
                  :content="totalCountPatients.pagination.total"
                  overlap
                  offset-x="10"
                  offset-y="25"
                >
                  <v-icon :class="{rotateIcon: !item.link && !mini}">{{ item.icon }}</v-icon>
                </v-badge>
              </template>
              <template v-else>
                <v-icon :class="{rotateIcon: !item.link && !mini}">{{ item.icon }}</v-icon>
              </template>
            </v-list-item-icon>
            <template v-if="item.name === 'Customers'">
              <v-list-item-title style="font-size: 14px" class="bold--text" :class="{hideMenuTitles: !mini}">
                {{item.name}}
                <span v-if="totalCountPatients && totalCountPatients.pagination" class="count-patients"> {{totalCountPatients.pagination.total}}</span>
              </v-list-item-title>
            </template>
            <template v-else>
              <v-list-item-title style="font-size: 14px" class="bold--text" :class="{hideMenuTitles: !mini}">
                {{item.name}}
              </v-list-item-title>
            </template>
          </v-list-item>
        </template>
      </v-list>

    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

import Image from '@/mixins/Image'
import Img from '@/components/elements/Img'

export default {
  name: 'drawer',
  mixins: [Image],
  props: {
    items: {
      type: Array
    }
  },
  components: {
    Img
  },
  data: () => ({
    mini: true
  }),
  mounted () {
    if (sessionStorage.getItem('selectedPage') && this.$route.path !== sessionStorage.getItem('selectedPage')) {
      this.$router.push(sessionStorage.getItem('selectedPage'))
    }
  },
  methods: {
    ...mapMutations('dialogs', ['TOGGLE_DIALOG']),
    isVisible (item) {
      return ((!item.onlyAuth) || (item.onlyAuth === this.isAuth))
    },
    goToByLink (item) {
      if (item.link && item.link !== this.$route.path) {
        this.$router.push(item.link)
        this.saveCurrentPage(item.link)
      }
      if (!item.link) {
        this.toggleCollapseMenu()
      }
    },
    saveCurrentPage (page) {
      sessionStorage.setItem('selectedPage', page)
    },
    toggleCollapseMenu () {
      this.mini = !this.mini
      this.$emit('toggleDrawer', this.mini)
    }
  },
  computed: {
    ...mapState({
      isAuth: state => state.isAuth,
      totalCountPatients: state => state.customers.customers
    }),
    filteredItemsOnlyAuth () {
      return this.items.filter(item => {
        return ((!item.onlyAuth) || (item.onlyAuth === this.isAuth))
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .drawer {
    ::v-deep .v-navigation-drawer {
      width: 180px!important;
      &__content {
        overflow-y: hidden;
        > .v-list-item {
          padding: 0;
          margin: 0;
          cursor: pointer;
          height: 90px;
          max-height: 90px;
        }
        .v-list {
          padding: 0 !important;
          margin: 0 !important;
          .v-list-item {
            height: 54px;
            max-height: 54px;
            margin: 0 !important;
            padding: 0 !important;
            position: relative;
            &:hover {
              &::after {
                content: '' !important;
                position: absolute !important;
                left: 0 !important;
                height: 100% !important;
                width: 2px !important;
                background-color: $dark-green !important;
              }
            }
            &--active {
              color: $dark-green;
              &::after {
                content: '' !important;
                position: absolute !important;
                left: 0 !important;
                height: 100% !important;
                width: 2px !important;
                background-color: $dark-green !important;
              }
              .v-list-item__title {
                color: $dark-green !important;
                font-weight: 500;
              }
              &::before {
                opacity: 0;
              }
            }
            &__icon {
              padding: 0 !important;
              margin: 0 !important;
              width: 90px;
              height: 100%;
              justify-content: center;
            }
          }
          .v-list-item.active-tab {
            .v-list-item__icon {
              .v-icon {
                color: $dark-green;
              }
            }
            .v-list-item__title {
              color: $dark-green;
            }
          }
        }
      }
    }
    .count-patients {
      background: #7cdbc1;
      border-radius: 50%;
      padding: 2px 6px;
      display: inline-block;
      color: white;
    }
    .collapseMenu {
      width: 56px !important;
    }
    .hideMenuTitles {
      position: absolute !important;
      height: 1px;
      width: 1px;
      overflow: hidden;
      clip: rect(1px, 1px, 1px, 1px);
      white-space: nowrap;
      display: initial;
    }
    .rotateIcon {
      transform: rotateZ(180deg);
    }
    .active-tab {
      background-color: #008c8938;
    }
  }
</style>
